import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function PartnerOverview() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);
  return <section data-section-id="51882" id="welcome-hero" className="relative min-h-[85vh] w-full overflow-hidden bg-[#0a1222] flex items-center py-20">
      {}
      <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-[hsl(43,89%,55%)] opacity-20 blur-[40px] pointer-events-none" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[600px] h-[600px] rounded-full bg-[hsl(43,89%,55%)] opacity-15 blur-[40px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isLoaded ? "translate-y-0 opacity-100" : "translate-y-[20px] opacity-0"}`}>
            <h1 className="font-serif font-black text-5xl md:text-6xl lg:text-[5rem] leading-[1.1] tracking-tight text-[hsl(255,65%,85%)]">
              Healing Through <br />
              Every Story
            </h1>
            
            <p className="font-sans font-medium text-lg md:text-xl text-white/90 leading-relaxed tracking-wide max-w-xl">
              Discover a sanctuary where creativity meets recovery. We empower children facing health challenges to find their voice through art and narrative, turning every hospital room into a canvas of infinite possibilities.
            </p>
            
            <p className="font-sans text-base md:text-lg text-white/80 leading-relaxed max-w-xl">
              Your partnership sustains our mission to provide a safe, guided space where children and families can express their life experiences, building emotional resilience and finding hope through the power of story.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild size="lg" className="bg-[hsl(43,89%,55%)] text-[#0a1222] hover:bg-[hsl(43,89%,45%)] rounded-full px-8 h-14 text-base font-bold shadow-[0_0_25px_rgba(234,179,8,0.4)] transition-transform hover:scale-105">
                <Link to="/ShareYourStoryPage">
                  Share Your Journey
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-white/20 text-white hover:bg-white/10 hover:text-white rounded-full px-8 h-14 text-base font-medium backdrop-blur-sm">
                <Link to="/StoryLibraryPage">
                  Explore Library
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${isLoaded ? "translate-y-0 opacity-100" : "translate-y-[40px] opacity-0"}`}>
            <div className="relative w-full max-w-[600px] aspect-square">
              {}
              <div className="w-full h-full overflow-hidden shadow-2xl bg-white/5" style={{
              borderRadius: "42% 58% 70% 30% / 45% 45% 55% 55%",
              boxShadow: "0 20px 50px -12px rgba(0, 0, 0, 0.5)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/child_art_golden_hour.png" alt="Child engaged in art during golden hour" className="w-full h-full object-cover scale-110 hover:scale-105 transition-transform duration-700 ease-in-out" />
              </div>
              
              {}
              <div className="absolute -z-10 top-10 right-10 w-full h-full border-2 border-white/10 rounded-[58%_42%_30%_70%_/_55%_55%_45%_45%] animate-[spin_20s_linear_infinite]" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}